"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _cardWithLinkList = _interopRequireDefault(require("../../components/cardWithLinkList"));
var _utils = require("../../utils");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 *  A react component to create a horizontal card with a link list
 *
 * @param {object} props The properties passed into the object
 * @param {object} props.rendering Fields to render
 * @param {object} props.rendering.fields Fields
 *
 * @returns {React.ReactElement} A horizontal card with Links
 */
function CardLinkList(props) {
  if (!props.rendering.fields) return null;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "app-container hcardlinks"
  }, /*#__PURE__*/_react.default.createElement(_cardWithLinkList.default, {
    fields: (0, _utils.extractFieldsFn)(props),
    params: props.params
  }));
}
var _default = exports.default = CardLinkList;